import { isNil } from 'lodash';
import { useContext } from 'react';
import { MBImage } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBRemoveAttachmentButton } from '@shared/scenes/chat/input/components/attachment/row';
import { ColorThemeContext, Colors, grid } from '@shared/styles';
import { useGoogleMapsImageUrl, useOpenMap } from './utils';

interface Props {
  lat: number;
  lon: number;
  width?: number;
  height?: number;
  iconUrl?: string;
  onClear?(): void;
}

export function GeolocationMapPreview({ lat, lon, iconUrl, width, height, onClear }: Props) {
  const colors = useContext(ColorThemeContext);
  const openMap = useOpenMap(lat, lon);
  const googleMapsImageUrl = useGoogleMapsImageUrl({
    lat,
    lon,
    iconUrl,
    scale: 1,
    zoom: 15,
    size: '400x400',
  });

  return (
    <MBTouchableOpacity
      style={[
        {
          borderRadius: grid(1),
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          borderColor: Colors.v2.gray20,
          borderWidth: 1,
          overflow: 'hidden',
          margin: -1,
        },
      ]}
      onPress={openMap}
    >
      <MBImage
        source={{ uri: googleMapsImageUrl }}
        style={{
          width: width ?? '100%',
          height: height ?? grid(12),
          backgroundColor: colors.backgroundInactive,
          overflow: 'hidden',
        }}
      />
      {!isNil(onClear) && <MBRemoveAttachmentButton onPress={onClear} />}
    </MBTouchableOpacity>
  );
}
